module.exports = __webpack_public_path__ + "d308073b/img/document.e2130c6b.svg";